import { useRouter } from 'next/router';
import type React from 'react';
import { type FunctionComponent } from 'react';

import { Button } from '@/domains/core/tamagoshiTailwind/components/Button/Button';
import { Typography } from '@/domains/core/tamagoshiTailwind/components/Typography/Typography';
import { Gtm } from '@/domains/core/tracking/utils/Gtm';
import { GTM_CLICK_ON_B2B_CONNECT_BUTTON } from '@/domains/retention/Footer/tracking/gtmEvents';

import {
  footerB2cConnectProLink,
  footerProButtonTitle,
  footerTrustProSubtitle,
  footerTrustProTitle,
} from '../../translations';

export const B2BConnect: FunctionComponent = () => {
  const router = useRouter();

  const handleClick = () => {
    Gtm.push(GTM_CLICK_ON_B2B_CONNECT_BUTTON());
    const loginURLWithMarket = `${footerB2cConnectProLink}`;
    router.push(loginURLWithMarket);
  };

  return (
    <div
      id="b2bConnectContainer"
      className="b2b flex flex-col items-center gap-m bg-accent-secondary p-xl
        text-center text-foundation-primary"
    >
      <Typography
        scale="title3"
        weight="bold"
        className="flex flex-col items-center"
      >
        <span>{footerTrustProTitle}</span>
        <span>{footerTrustProSubtitle}</span>
      </Typography>
      <Button
        fitContent
        variant="primary"
        text={footerProButtonTitle}
        size="L"
        onClick={handleClick}
      />
    </div>
  );
};

B2BConnect.displayName = 'B2BConnect';
